import React, { useEffect, useState } from 'react'

import './salepage.css'




import { ReactSVG } from 'react-svg'
import TsSliders from '../assets/TSSliders2.svg'
import YoutubeEmbed from './YoutubeEmbed'
import ReactPlayer from 'react-player'
import { UserAuth } from '../context/AuthContext'
import { Link, useNavigate, useParams } from 'react-router-dom'

import { motion } from "framer-motion"

import vstimg from '../assets/VSTLogoTs.png'
import auimg from '../assets/AULogoTS.png'
import aaximg from '../assets/AAXLogoTS.png'

import { analytics } from '../firebase'
import { logEvent } from 'firebase/analytics';

import { db } from "../firebase"
import {
  doc,
  collection,
  onSnapshot,
  setDoc,
  deleteDoc,
  query,
  where,
  getDocs,
  orderBy,
  getDoc,
  serverTimestamp,
  FieldValue,
  arrayUnion,
  updateDoc
} from "firebase/firestore"


const Salepage = () => {
  const [alreadyOwnesProduct, setAlreadyOwnesProduct] = useState(false);
  const [allOwnedProducts, setAllOwnedProducts] = useState([]);
  const [foundUser, setFoundUser] = useState(false);

  const { user } = UserAuth();
  const navigate = useNavigate()

  const [product, setProduct] = useState(null);
  const [checkout, setCheckout] = useState(null);

  const [price, setPrice] = useState(29.99);

  const params = useParams();


  function commenceToPurchase() {
    if (alreadyOwnesProduct) {

    } else {
      navigate(`/purchase/aurora/succesful`);
    }
  }

  const buyProduct = () => {
    logEvent(analytics, "SalePage_Aurora_BuyNow");
    navigate('/checkout', { state: { product: { id: 1, name: "Aurora", price: price } } });
  };


  useEffect(() => {
    console.log(foundUser)
  }, [foundUser])




  useEffect(() => {
    const hasYon = allOwnedProducts.some((product) => product.name === "aurora");
    if (hasYon) {
      setAlreadyOwnesProduct(true);
    }
  }, [allOwnedProducts])

  useEffect(() => {
    if (params.country === "iceland") {
      setPrice(29.99);
    }
  }, [])

  useEffect(() => {

  }, [alreadyOwnesProduct])


  return (
    <div className='salepage__container'>
      <div className="salepage__img"></div>
      <div className="salepage__ontop">

        <motion.div className="salepage__prodimg"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <div className='salepage__pluginimgsize'>
            <ReactPlayer url={"videos/AuroraTestLoop2.mp4"}
              width='100%'
              height='100%'
              loop={true}
              playing={true}
              muted={true}
              playsinline={true}
            />
          </div>
        </motion.div>

        <div className="salepage__prodinfo">
          <div className="salepage__leftside">
            <motion.div className="salepage__title"
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2, duration: 0.5 }}
            >
              Aurora
            </motion.div>

            <motion.div className="salepage__description"
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4, duration: 0.5 }}
            >
              Introducing the Aurora Tape Delay, a true audio enchanter that will breathe new life into your tracks.
            </motion.div>
          </div>

          <motion.div className="salepage__sliders"
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.6, duration: 0.5 }}
          >
            <ReactSVG src={TsSliders} className="salepage__sliderssize" />
          </motion.div>

          <div className="salepage__rightside">
            <motion.div className="salepage__titleright"
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2, duration: 0.5 }}
            >
              Tape Delay
            </motion.div>

            <motion.div className="salepage__price"
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4, duration: 0.5 }}
            >
              <span>$49.99</span>${price}
            </motion.div>

            <motion.div className="salepage__addtocartbutton"
              onClick={buyProduct}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              viewport={{ once: true }}
              transition={{ delay: 0.6 }}
            >
              <div className="salepage__buttontext">
                {alreadyOwnesProduct ? "Owned" : "Buy Now"}
              </div>
            </motion.div>

            <motion.div className="salepage__addtocartbuttonphone"
              onClick={buyProduct}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.6 }}
            >
              <div className="salepage__buttontext">
                {alreadyOwnesProduct ? "Owned" : "Buy Now"}
              </div>
            </motion.div>

          </div>
        </div>

        <motion.div className="salepage__video"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <YoutubeEmbed embedId="EVbq5QhXOqQ?si=3ZfTXZFhBYW" />
        </motion.div>

        <div className="salepage__moreinfo">
          <motion.div className="salepage__infobox"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            <div className="salepage__infoboxtitle">
              Requirements
            </div>
            <div className="salepage__infoboxtext">
              macOS
              macOS 10.13 or higher (64-bit only)
              AU or VST3 host or Pro Tools
              Apple Silicon or Intel processor
              <br /><br />
              The computer must be connected to the internet at the time of product registration. After the completion of registration, the software is designed to function offline.
              <br /><br />
              Windows support coming soon...
            </div>
          </motion.div>

          <motion.div className="salepage__infobox"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 }}
          >
            <div className="salepage__infoboxtitle">
              Plug-in formats
            </div>
            <div className="salepage__infoboxtext">
              Tape Signal plug-ins are available
              in VST, VST3, Audio Units, AAX Native
              and AudioSuite formats.
            </div>
            <div className="salepage__formatimgs">
              <img src={vstimg} alt="VST" />
              <img src={auimg} alt="AU" />
              <img src={aaximg} alt="AAX" />
            </div>
          </motion.div>
        </div>

      </div>



    </div>
  )
}

export default Salepage